import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RolUserListComponent } from './rolUserList/rolUser.component';
import { NgModule } from '@angular/core';
import { RolService } from '../../security/Roles/shared/rol.service';
import {RolUserService} from '../rolUser/shared/rolUser.service'
import {RolUserRoutingModule,ROUTABLE_COMPONENTS} from '../rolUser/rolUser.routing';
import { MatButtonModule, MatInputModule, MatCheckboxModule, MatSlideToggleModule, MatTableModule,MatFormFieldModule,MatPaginatorModule } from '@angular/material';
import { FabButtonGroupModule } from '../../../shared/fabbuttongroup/fabbuttongroup.module';
import { SectionBarModule } from '../../../shared/sectionbar/sectionbar.module';
import {RolUserOutComponent} from '../rolUser/rolUserOut.component'

//ccontrols
import { TitlebarModule } from '../../../shared/titlebar/titlebar.module';
import { HeaderModule } from '../../../shared/header/header.module';
import { LoaderModule } from '../../../shared/loader/loader.module';
import { SnackbarModule } from '../../../shared/snackbar/snackbar.module';

@NgModule({
    imports: [
      BrowserModule,
      FormsModule, ReactiveFormsModule,
      RolUserRoutingModule,
      MatTableModule, MatCheckboxModule, MatButtonModule, MatInputModule, MatSlideToggleModule,
      MatFormFieldModule,MatPaginatorModule,
      FabButtonGroupModule, SectionBarModule,
      TitlebarModule, HeaderModule, LoaderModule, SnackbarModule
    ],
    entryComponents: [],
    exports: [],
    declarations: [

        RolUserListComponent,
        RolUserOutComponent,
        ROUTABLE_COMPONENTS
    ],
    providers: [RolService,RolUserService],
    bootstrap: []
})
export class RolUserModule {
}
